<template>
  <div>
    <p class="time-answer__text">
      <span
        v-html="
          $t('youAnsweredIn', {
            msg: '<strong>' + getTimeCount(timeAnswer) +'</strong>',
            num: getTimeCount(timeLeft)
          })
        "
        v-if="timeAnswer"
      />
      <br><span>{{ $t("waitAndSeeHowYouDid") }}</span>
    </p>
  </div>
</template>

<script>
import Utils from '@/util'

export default {
  props: {
    timeAnswer: {
      type: Number,
      default: 0,
    },
    timeLeft: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getTimeCount(second) {
      return Utils.getTimeCount(second, this)
    },
  },
}
</script>

<style lang="scss" scoped>
.time-answer__text {
  font-size: 14px;
  line-height: 18px;
}
</style>
